<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap">
                <div>
                    <div>
                        <img src="@/assets/images/charging-cancel.png" alt="" />
                    </div>
                    <span>
                        {{ message }}
                    </span>
                </div>
            </div>
            <button class="button-bg-gray border-left-round" @click="noEvent()">아니오</button>
            <button class="button-bg-yellow border-right-round" @click="yesEvent()">예</button>
        </div>
    </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
export default {
    name: 'confirmPopup',
    props: ['message'],
    components: {BottomButton},
    data() {
        return {

        }
    },
    methods: {
        noEvent() { //아니오 버튼 눌렀을때 이벤트
            this.$emit('confirmPopupClickNo', 'no');
        },
        yesEvent() {    //예 버튼 눌렀을때 이벤트
            this.$emit('confirmPopupClickYes', 'yes');
        }
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/cards/cancelChargingPopup.scss';
</style>